/**
 * SC-209: the Document Picture-in-Picture API, typed.
 *
 * It is not in `lib.dom` — it is a WICG specification, shipped in Chromium since 2023 and Firefox since 151 —
 * so these are the only declarations of it we have. Kept narrow on purpose: only what we call.
 */

export interface DocumentPictureInPictureOptions {
  width?: number
  height?: number
  /** Deliberately unused. Both of these change where the window opens and we let the browser decide. */
  disallowReturnToOpener?: boolean
  preferInitialWindowPlacement?: boolean
}

export interface DocumentPictureInPictureApi {
  requestWindow(options?: DocumentPictureInPictureOptions): Promise<Window>
  readonly window: Window | null
}

export type WindowWithDocumentPip = Window & {
  documentPictureInPicture?: DocumentPictureInPictureApi
}

/** `true` when this browser can give us a second document — the check `pipCapability` is handed. */
export function hasDocumentPip(win: Window = window): boolean {
  return typeof (win as WindowWithDocumentPip).documentPictureInPicture?.requestWindow === 'function'
}

export function documentPipApi(win: Window = window): DocumentPictureInPictureApi | null {
  return hasDocumentPip(win) ? (win as WindowWithDocumentPip).documentPictureInPicture! : null
}

/** The older single-video API, which is all Safari has — the other half of `pipCapability`'s input. */
export function hasVideoPip(doc: Document = document): boolean {
  return doc.pictureInPictureEnabled === true
}
